<template>
  <div class="card">
    <div class="card-body">
      <p class="control-box-text">Ihre aktuelle Vorauswahl:</p>
      <InfoBox />
      <div class="system-price">
        <div class="system-price__row">
          <div class="title-secondary bold-weight">Aktueller Preis:</div>
          <div class="system-price__values">
            <div class="total-price total-price--discount">{{ $filters.currency(currentPrice) }}</div>
            <div v-if="showOldPrice" class="total-price total-price--old">{{ $filters.currency(oldPrice) }}</div>
          </div>
        </div>
        <div class="text-ink system-price__note">(inkl. 19% MwSt. zzgl. Versandkosten)</div>
        <a class="btn btn-outline-primary w-100" data-bs-toggle="modal" href="#requestModal">Unverbindliche Anfrage</a>
        <a class="btn btn-primary w-100" href="#" @click.prevent="addToCart">In den Warenkorb</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import InfoBox from '@/pages/system/common/InfoBox.vue'

const store = useStore()
const router = useRouter()
const prices = computed(() => store.getters['system/getTotalPrice'])
const montageStatus = computed(() => store.getters['checkout/montageStatus'])
const montageCost = computed(() => store.getters['checkout/montageCost'])

const discounted = computed(() => {
  if (prices.value && prices.value.discounted > 0) {
    return prices.value.discounted
  }
  return 0
})
const price = computed(() => {
  if (prices.value && prices.value.price) {
    return prices.value.price
  }
  return 0
})
const montageExtra = computed(() => (montageStatus.value ? montageCost.value : 0))
const currentPrice = computed(() => {
  const base = discounted.value > 0 ? discounted.value : price.value
  return base + montageExtra.value
})
const oldPrice = computed(() => price.value + montageExtra.value)
const showOldPrice = computed(() => discounted.value > 0 && oldPrice.value > currentPrice.value)

function addToCart () {
  const summary = store.getters['system/summary'] || {}
  const productItems = summary.products || []

  productItems.forEach(product => {
    const item = product.summary
    if (!item) {
      return
    }
    store.dispatch('checkout/addItem', {
      id: item.id,
      name: item.name,
      images: item.images || [],
      quantity: product.amount || 1,
      price: {
        discounted: item.price?.discounted || 0,
        total: item.price?.discounted || item.price?.total || 0,
        old_price: item.price?.total || 0
      },
      steps: item.steps || []
    })
  })

  setTimeout(() => {
    router.push({ name: 'cart' })
  }, 300)
}
</script>
<style scoped>
.system-price__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.system-price__values {
  flex-shrink: 0;
  text-align: right;
}

.system-price__note {
  display: block;
  margin: 4px 0 12px;
}

.system-price .btn {
  margin-bottom: 8px;
}
</style>
